export default __webpack_public_path__ + "fonts/tpl_4.284c1a0aa4a33bcb8a52b2b8e1995d69.png";